import { CSSInterpolation } from '@mui/system';
import colors from '../../base/colors';

const root = {
  // border: `1px solid ${colors.outline.main}`,
} as CSSInterpolation;

export default {
  root,
};
